import React, { useEffect, useState, memo } from 'react'
import cx from 'classnames'
import { map } from 'rxjs/operators'
import ReactResizeDetector from 'react-resize-detector'
import MobileMenuContainer from 'redux/containers/components/layout/mobile-menu/MobileMenuContainer'
import NavigationOverlayContainer from 'redux/containers/components/NavigationOverlayContainer'
import PageWrapperContainer from 'redux/containers/components/layout/PageWrapperContainer'
import CookiePolicy from 'components/layout/CookiePolicy'
import HelpOverlay from 'components/layout/HelpOverlay'
import MobileScrollBlocker from './layout/MobileScrollBlocker'
import SignUpModalContainer from 'redux/containers/components/SignUpModalContainer'
import IncorrectUserRoleModalContainer from 'redux/containers/components/IncorrectUserRoleModalContainer'

import useObservable from 'front-end-core/hooks/useObservable'
import { Resize } from 'front-end-core/services/WindowService'
import { isEqual } from 'libraries/lodash'
import ResizeHeader from './ResizeHeader'
import ServiceUnavailableBanner from './service-unavailability-banner'

const arePropsEqual = (prevProps, nextProps) => isEqual(prevProps, nextProps)

const LayoutComponent = memo((
  props
) => {
  const {
    pageId,
    className,
    fullscreenOverlay,
    act,
    flavour,
    sectionId,
    setLayoutState,
    setLayoutFlavour,
    setWindowSize,
    setLegislationAct,
    setQASectionId,
    aol,
    isNavigationVisible,
    left,
    right,
    browser,
    setLayoutHeaderHeight
  } = props

  const [freeTrialHeight, setFreeTrialHeight] = useState(0)
  const appContentDynamicStyle = { marginTop: freeTrialHeight }
  const hasAol = aol?.length > 0

  const classes = cx('application', className, {
    'show-navigation': isNavigationVisible,
    [`flavour-${flavour}`]: true,
    [`browser-${browser.name}`]: true,
    'has-left': !!left,
    'has-right': !!right
  })

  const windowWidth = useObservable(
    Resize.pipe(map(() => window.innerWidth)),
    window.innerWidth
  )

  const windowHeight = useObservable(
    Resize.pipe(map(() => window.window.innerHeight)),
    window.innerHeight
  )

  useEffect(() => {
    setLayoutState({ pageId })
  })

  useEffect(() => {
    flavour && setLayoutFlavour(flavour)
  }, [flavour])

  useEffect(() => {
    act && setLegislationAct(act)
  }, [act])

  useEffect(() => {
    setQASectionId(sectionId)
  }, [sectionId])

  useEffect(() => {
    setWindowSize({ windowWidth, windowHeight })
  }, [windowWidth, windowHeight])

  return (
    <div className={classes}>
      <ServiceUnavailableBanner />
      <MobileScrollBlocker />
      <MobileMenuContainer pageId={pageId} headerHeight={freeTrialHeight} />
      <NavigationOverlayContainer />
      <div className='fixed top0 w-100 bg-white z25'>
        <ReactResizeDetector handleHeight>
          <ResizeHeader
            setLayoutHeaderHeight={setLayoutHeaderHeight}
            handleSetFreeTrialHeight={setFreeTrialHeight}
            headerProps={{ ...props, isSearchBarVisible: hasAol, isDesktopNavigationVisible: hasAol }}
          />
        </ReactResizeDetector>
      </div>
      <div style={appContentDynamicStyle} />{/* spaaaacing to use fixed instead of sticky, because IE */}
      <div>
        <SignUpModalContainer />
        <IncorrectUserRoleModalContainer />
        <PageWrapperContainer key={pageId} {...{ pageId }} {...props} headerHeight={freeTrialHeight} />
      </div>
      <CookiePolicy />
      <HelpOverlay />
      {fullscreenOverlay}
    </div>
  )
}, arePropsEqual)

export default LayoutComponent
